// 普通项目域名匹配
var PROJECT_MAP = {
  'fe-middle-pc': 'midDomain',
  'fe-user-pc': 'pcDomain',
  transaction: 'pcDomain',
  'fe-signin-pc': 'pcDomain',
  'fe-job-pc': 'pcDomain',
  'fe-enroll-pc': 'pcDomain',
  'fe-exam-pc': 'orgDomain',
  'fe-business-pc': 'orgDomain',
  'fe-organization-pc': 'burl',
  'fe-user-h5': 'wapDomain',
  'fe-cloud-h5': 'midMobileDomain',
  'fe-business-h5': 'portalH5Url',
  'fe-enroll-h5': 'wapDomain',
  'fe-exam-h5': 'wapDomain',
  'fe-signin-h5': 'wapDomain',
  'fe-ai-h5': 'portalH5Url',
  'fe-questionnaire-h5': 'wapDomain',
  'fe-job-h5': 'wapDomain'
};

// 资源方项目域名匹配
var SPECIAL_PROJECT_MAP = {
  'fe-user-pc': 'merchantUserDomain',
  'fe-merchant-pc': 'merchantMidDomain',
  'fe-job-pc': 'merchantMidDomain',
  'fe-exam-pc': 'merchantMidDomain',
  'fe-business-pc': 'merchantMidDomain',
  'fe-organization-pc': 'burl',
  'fe-user-h5': 'merchantUserMobileDomain',
  'fe-business-h5': 'portalH5Url',
  /** TODO 目前移动端只有 讲师中心 */
  'fe-cloud-h5': 'lecturerMobileDomain'
};
var isMobile = function isMobile() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 对于iPhone和iPad的浏览器，用户代理字符串包含 "Mobile" 或 "Safari"，所以我们需要首先排除这些情况
  if (/mobile|tablet|ip(hone|od)|android/i.test(userAgent)) {
    return true;
  }
  // 对于非移动设备的浏览器，返回false
  return false;
};
var getLocalDomain = function getLocalDomain(domainJson, packageName) {
  // 当前的基座标志
  var platform = '';
  if (window.location.hostname === 'localhost' || ALIAS_ENV !== 'global') {
    if (Object.prototype.toString.call(domainJson) !== '[object Object]') {
      return '';
    }
    platform = sessionStorage.getItem('platform') || '';
    var isPc = !isMobile();
    var SPECIAL_USER = Number(domainJson.SPECIAL_USER || 0);
    // 特殊身份时特殊返回(资源方)
    if (SPECIAL_USER === 1) {
      switch (platform) {
        case 'workbench':
          if (isPc) {
            localStorage.setItem('currentDomain', domainJson.merchantMidDomain);
            return domainJson.merchantMidDomain;
          } else {
            localStorage.setItem('currentDomain', domainJson.merchantMidDomain);
            return domainJson.merchantMidDomain;
          }
        default:
          if (domainJson[SPECIAL_PROJECT_MAP[packageName]] !== '') {
            localStorage.setItem('currentDomain', domainJson[SPECIAL_PROJECT_MAP[packageName]]);
            return domainJson[SPECIAL_PROJECT_MAP[packageName]];
          } else {
            localStorage.setItem('currentDomain', domainJson.merchantUserDomain);
            return domainJson.merchantUserDomain;
          }
      }
    } else {
      /**
       * 普通域名匹配规则
       * 1、当存在于门户中时，返回门户域名
       * 2、非门户时，根据项目名返回对应域名
       * */
      switch (platform) {
        case 'portal':
          if (isPc) {
            localStorage.setItem('currentDomain', domainJson.burl);
            return domainJson.burl;
          } else {
            localStorage.setItem('currentDomain', domainJson.portalH5Url);
            return domainJson.portalH5Url;
          }
        default:
          // @ts-ignore
          if (domainJson[PROJECT_MAP[packageName]] !== '') {
            // @ts-ignore
            localStorage.setItem('currentDomain', domainJson[PROJECT_MAP[packageName]] || '');
            // @ts-ignore
            return domainJson[PROJECT_MAP[packageName]] || '';
          } else {
            localStorage.setItem('currentDomain', domainJson.pcDomain);
            return domainJson.pcDomain;
          }
      }
    }
  } else {
    return window.location.origin;
  }
};
export default getLocalDomain;